import React, { useRef, useEffect } from 'react';

import { useLayoutContext } from '@ott/layout-context';

import { S3_IMAGES_URL } from '../../../../constants';

import { motion, useInView, useAnimation } from 'framer-motion';

type Props = { className?: string };

const OrbitTwo = ({ className }: Props) => {
  const ref = useRef(null);
  const inViewport = useInView(ref);
  const control = useAnimation();
  const { isDesktop } = useLayoutContext();

  const variants = {
    initial: isDesktop
      ? { opacity: 0, scale: 0 }
      : { opacity: 0, scale: 0, left: '50%', right: '50%', x: '-50%', y: '-2%' },
    animate: isDesktop
      ? {
          opacity: 0.7,
          scale: 1,
          transition: { duration: 0.57 },
        }
      : {
          opacity: 0.7,
          scale: 0.7,
          rotate: 15,
          transition: { duration: 0.57 },
        },
  };

  useEffect(() => {
    if (inViewport) {
      control.start('animate');
    }
  }, [control, inViewport, isDesktop]);

  return (
    <motion.svg
      ref={ref}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="583"
      height="250"
      fill="none"
      variants={variants}
      initial="initial"
      animate={control}
    >
      <path
        id="orbitTwo"
        stroke="url(#a)"
        strokeWidth="2"
        shapeRendering="geometricPrecision"
        d="M580.759 202.97c-3.545 13.228-14.924 23.766-32.642 31.451-17.712 7.682-41.679 12.475-70.231 14.253-57.098 3.555-132.415-4.955-212.407-26.389-79.993-21.434-149.474-51.722-197.145-83.35-23.838-15.816-42.198-31.95-53.696-47.46C3.138 75.962-1.448 61.146 2.096 47.918 5.64 34.69 17.02 24.151 34.737 16.467 52.45 8.783 76.417 3.99 104.968 2.212c57.098-3.555 132.415 4.956 212.408 26.39 79.992 21.433 149.474 51.722 197.144 83.349 23.838 15.816 42.198 31.95 53.696 47.459 11.502 15.515 16.087 30.331 12.543 43.559Z"
      />
      <defs>
        <linearGradient
          id="a"
          x1="526.657"
          x2="108.468"
          y1="16.731"
          y2="227.455"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EED7F1" />
          <stop offset=".085" stopColor="#FEFCFE" />
          <stop offset=".192" stopColor="#DBC1D4" />
          <stop offset=".285" stopColor="#6DD2E5" />
          <stop offset=".4" stopColor="#7BA0EB" />
          <stop offset=".51" stopColor="#BC86F6" />
          <stop offset=".632" stopColor="#DCC4F8" />
          <stop offset=".747" stopColor="#BFB5C6" />
          <stop offset=".87" stopColor="#F5F4F6" />
          <stop offset="1" stopColor="#D7CACE" />
        </linearGradient>
      </defs>
      <image
        href={`${S3_IMAGES_URL}planets_for_orbits/planet-2@2x.png`}
        width="50"
        height="50"
        x="220"
        y="190"
      >
        <mpath href="#orbitTwo" />
      </image>
    </motion.svg>
  );
};

export default OrbitTwo;
